let holidayDataPromise = null;

export function getHolidayData () {
	// Normalize country code (defaults to "se")
	const countryCode = js_params?.countryCode?.toLowerCase?.() || 'se';

	// If we’ve already started (or finished) loading this country’s data, return it.
	if (holidayDataPromise) {
		return holidayDataPromise;
	}

	// Otherwise, create the import promise once and store it in holidayDataPromise.
	switch (countryCode) {
		case 'de':
			holidayDataPromise = import('./data/de').then(mod => mod.holidayData);
			break;
		case 'dk':
			holidayDataPromise = import('./data/dk').then(mod => mod.holidayData);
			break;
		case 'fi':
			holidayDataPromise = import('./data/fi').then(mod => mod.holidayData);
			break;
		case 'fr':
			holidayDataPromise = import('./data/fr').then(mod => mod.holidayData);
			break;
		case 'ie':
			holidayDataPromise = import('./data/ie').then(mod => mod.holidayData);
			break;
		case 'no':
			holidayDataPromise = import('./data/no').then(mod => mod.holidayData);
			break;
		case 'se':
			holidayDataPromise = import('./data/se').then(mod => mod.holidayData);
			break;
		case 'za':
			holidayDataPromise = import('./data/za').then(mod => mod.holidayData);
			break;
		default:
			holidayDataPromise = Promise.resolve({});
	}

	return holidayDataPromise;
}
